/* ═══════════════════════════════════════════════════
   Kaalp Studios — Collection Filters JS
   AJAX-powered, URL-based Shopify native filters
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PRICE_MAX = 8000;
  var pendingFetch = null;

  /* ══════════════════════════════════
     1. DRAWER STATE MANAGEMENT
     ══════════════════════════════════ */
  function getDrawerElements() {
    return {
      drawer: document.querySelector('[data-filter-drawer]'),
      overlay: document.querySelector('[data-filter-overlay]')
    };
  }

  function openDrawer() {
    var els = getDrawerElements();
    if (els.drawer) {
      els.drawer.classList.add('is-active');
      els.drawer.setAttribute('aria-hidden', 'false');
    }
    if (els.overlay) els.overlay.classList.add('is-active');
    document.body.classList.add('no-scroll');
    var toggleBtn = document.querySelector('[data-filter-toggle]');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    var els = getDrawerElements();
    if (els.drawer) {
      els.drawer.classList.remove('is-active');
      els.drawer.setAttribute('aria-hidden', 'true');
    }
    if (els.overlay) els.overlay.classList.remove('is-active');
    document.body.classList.remove('no-scroll');
    var toggleBtn = document.querySelector('[data-filter-toggle]');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  }

  /* ══════════════════════════════════
     2. PRICE RANGE SLIDER INITIALIZER
     ══════════════════════════════════ */
  function initPriceSliders(container) {
    var parent    = container || document;
    var minRange  = parent.querySelector('[data-price-min-range]');
    var maxRange  = parent.querySelector('[data-price-max-range]');
    var minInput  = parent.querySelector('[data-price-min]');
    var maxInput  = parent.querySelector('[data-price-max]');
    var trackFill = parent.querySelector('[data-price-track]');

    if (!minRange || !maxRange || !trackFill) return;

    var RANGE_MAX = parseFloat(minRange.getAttribute('max')) || PRICE_MAX;

    /* Read initial values — ensure max is always the full range if not set */
    var initMin = parseFloat(minRange.value);
    var initMax = parseFloat(maxRange.value);
    if (isNaN(initMin) || initMin < 0) initMin = 0;
    if (isNaN(initMax) || initMax <= 0 || initMax > RANGE_MAX) initMax = RANGE_MAX;
    if (initMin > initMax) initMin = 0;

    minRange.value = initMin;
    maxRange.value = initMax;
    if (minInput) minInput.value = Math.round(initMin);
    if (maxInput) maxInput.value = Math.round(initMax);

    function updateTrack() {
      var minVal   = parseFloat(minRange.value) || 0;
      var maxVal   = parseFloat(maxRange.value);
      if (isNaN(maxVal)) maxVal = RANGE_MAX;

      var leftPct  = (minVal / RANGE_MAX) * 100;
      var rightPct = (maxVal / RANGE_MAX) * 100;
      trackFill.style.left  = Math.max(0, leftPct) + '%';
      trackFill.style.width = Math.max(0, rightPct - leftPct) + '%';

      /* Keep whichever thumb is at the upper end on top */
      if (maxVal - minVal < RANGE_MAX * 0.03) {
        minRange.style.zIndex = '5';
        maxRange.style.zIndex = '4';
      } else {
        minRange.style.zIndex = '4';
        maxRange.style.zIndex = '5';
      }
    }

    minRange.addEventListener('input', function () {
      var minVal = parseFloat(minRange.value);
      var maxVal = parseFloat(maxRange.value);
      if (minVal > maxVal) { minRange.value = maxVal; minVal = maxVal; }
      if (minInput) minInput.value = Math.round(minVal);
      updateTrack();
    });

    maxRange.addEventListener('input', function () {
      var minVal = parseFloat(minRange.value);
      var maxVal = parseFloat(maxRange.value);
      if (maxVal < minVal) { maxRange.value = minVal; maxVal = minVal; }
      if (maxInput) maxInput.value = Math.round(maxVal);
      updateTrack();
    });

    if (minInput) {
      minInput.addEventListener('change', function () {
        var val    = parseFloat(minInput.value) || 0;
        var maxVal = parseFloat(maxRange.value);
        if (val < 0) val = 0;
        if (val > maxVal) val = maxVal;
        val = Math.round(val);
        minInput.value = val;
        minRange.value = val;
        updateTrack();
      });
    }

    if (maxInput) {
      maxInput.addEventListener('change', function () {
        var val    = parseFloat(maxInput.value);
        var minVal = parseFloat(minRange.value) || 0;
        if (isNaN(val) || val > RANGE_MAX) val = RANGE_MAX;
        if (val < minVal) val = minVal;
        val = Math.round(val);
        maxInput.value = val;
        maxRange.value = val;
        updateTrack();
      });
    }

    updateTrack();
  }

  /* ══════════════════════════════════
     3. URL BUILDING
     ══════════════════════════════════ */
  function buildFilterUrl(form) {
    /* Read current price display values (in rupees) from the number inputs directly */
    var minInputEl = form.querySelector('[data-price-min]');
    var maxInputEl = form.querySelector('[data-price-max]');

    var minRupees = minInputEl ? (parseFloat(minInputEl.value) || 0) : 0;
    
    // Dynamically read the max limit from the input element's max attribute
    var maxLimit = maxInputEl ? (parseFloat(maxInputEl.getAttribute('max')) || PRICE_MAX) : PRICE_MAX;
    var maxRupees = maxInputEl ? (parseFloat(maxInputEl.value) || maxLimit) : maxLimit;

    /* Build params from all form fields EXCEPT the price inputs (we'll add them ourselves) */
    var formData = new FormData(form);
    var params   = new URLSearchParams();

    var minParamName = minInputEl ? minInputEl.name : null;
    var maxParamName = maxInputEl ? maxInputEl.name : null;

    for (var pair of formData.entries()) {
      var key = pair[0];
      var val = pair[1];
      /* Skip the price inputs — we'll handle them correctly below */
      if (key === minParamName || key === maxParamName) continue;
      if (val !== '' && val !== null) {
        params.append(key, val);
      }
    }

    /* Only add price params if they differ from the full range (avoid no-op filters) */
    if (minParamName && minRupees > 0) {
      params.append(minParamName, Math.round(minRupees)); /* major units */
    }
    if (maxParamName && maxRupees < maxLimit) {
      params.append(maxParamName, Math.round(maxRupees)); /* major units */
    }

    /* Preserve sort_by if present in current URL */
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) {
      params.append('sort_by', currentSort);
    }

    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  /* ══════════════════════════════════
     4. AJAX PRODUCT FETCHING & SWAPPING
     ══════════════════════════════════ */
  function fetchFilteredProducts(url, skipPushState) {
    var gridWrap = document.getElementById('kaalp-collection-wrap');
    if (gridWrap) gridWrap.classList.add('is-loading');
    if (pendingFetch) pendingFetch.abort();

    var controller = new AbortController();
    pendingFetch = controller;

    /* Correctly append &sections= or ?sections= depending on whether ? already exists */
    var sep        = url.indexOf('?') !== -1 ? '&' : '?';
    var sectionsUrl = url + sep + 'sections=collection-grid';

    fetch(sectionsUrl, { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data['collection-grid']) {
          var parser = new DOMParser();
          var doc    = parser.parseFromString(data['collection-grid'], 'text/html');

          /* Swap product grid */
          var newWrap = doc.getElementById('kaalp-collection-wrap');
          if (newWrap && gridWrap) gridWrap.innerHTML = newWrap.innerHTML;

          /* Swap filter drawer and re-init sliders */
          var newDrawer = doc.getElementById('kaalp-filter-drawer');
          var oldDrawer = document.getElementById('kaalp-filter-drawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            initPriceSliders(oldDrawer);
          }
        }

        if (!skipPushState) window.history.pushState({}, '', url);

        var freshGridWrap = document.getElementById('kaalp-collection-wrap');
        if (freshGridWrap) freshGridWrap.classList.remove('is-loading');

        var collectionEl = document.getElementById('kaalp-collection');
        if (collectionEl) collectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          /* Fallback: full page navigation */
          window.location.href = url;
        }
      });
  }

  /* ══════════════════════════════════
     5. DELEGATED EVENT LISTENERS
     ══════════════════════════════════ */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      e.preventDefault();
      openDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-close]') || e.target.closest('[data-filter-overlay]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.filter-section__toggle');
    if (btn) {
      e.preventDefault();
      var section = btn.closest('.filter-section');
      if (section) {
        section.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', !section.classList.contains('is-collapsed'));
      }
    }
  });

  /* Apply Filters */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-filter-form]');
    if (form) {
      e.preventDefault();
      closeDrawer();
      var url = buildFilterUrl(form);
      fetchFilteredProducts(url);
    }
  });

  /* Active filter tag / Clear All */
  document.addEventListener('click', function (e) {
    var tag = e.target.closest('.active-filter-tag') || e.target.closest('[data-clear-filters]');
    if (tag) {
      e.preventDefault();
      var urlStr = tag.getAttribute('href');
      if (urlStr) {
        /* Preserve current sort_by */
        var currentSort = new URLSearchParams(window.location.search).get('sort_by');
        if (currentSort) {
          var urlObj = new URL(urlStr, window.location.origin);
          urlObj.searchParams.set('sort_by', currentSort);
          urlStr = urlObj.pathname + urlObj.search;
        }
        fetchFilteredProducts(urlStr);
      }
    }
  });

  /* Sort Dropdown Change */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sort-select]');
    if (select) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      fetchFilteredProducts(url.pathname + url.search);
    }
  });

  /* Subnav Category Links Click */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-subnav-link]');
    if (link) {
      e.preventDefault();
      var url = link.getAttribute('href');
      fetchFilteredProducts(url);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var els = getDrawerElements();
      if (els.drawer && els.drawer.classList.contains('is-active')) closeDrawer();
    }
  });

  window.addEventListener('popstate', function () {
    fetchFilteredProducts(window.location.href, true);
  });

  /* ══════════════════════════════════
     6. INITIALIZATION
     ══════════════════════════════════ */
  initPriceSliders();

})();
